import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ProductRail } from "@/components/ProductCard";
import { api } from "@/lib/api";
import { getCatViews, getRecent } from "@/lib/recentlyViewed";
import { CATEGORY_LABELS } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

// Personalised rail from the shopper's most-viewed category. Signed-in shoppers
// use server-side history (follows them across devices); guests fall back to
// localStorage category tallies.
export default function BecauseYouViewed() {
  const { user } = useAuth();
  const [state, setState] = useState({ slug: "", items: [] });
  useEffect(() => {
    let done = false;
    const fromLocal = () => {
      const views = getCatViews();
      const top = Object.keys(views).sort((a, b) => views[b] - views[a])[0];
      if (!top) return;
      api.get("/products", { params: { category: top, limit: 12 } }).then(({ data }) => {
        if (done) return;
        const seen = new Set(getRecent().map((r) => r.id));
        const fresh = data.filter((p) => !seen.has(p.id));
        setState({ slug: top, items: (fresh.length >= 4 ? fresh : data).slice(0, 10) });
      }).catch(() => {});
    };
    if (user) {
      api.get("/me/picks").then(({ data }) => {
        if (done) return;
        if (data.category && (data.products || []).length >= 4) {
          setState({ slug: data.category, items: data.products.slice(0, 10) });
        } else { fromLocal(); }
      }).catch(fromLocal);
    } else {
      fromLocal();
    }
    return () => { done = true; };
  }, [user]);
  if (state.items.length < 4) return null;
  const label = CATEGORY_LABELS[state.slug] || state.slug;
  return (
    <div data-testid="because-you-viewed">
      <ProductRail
        title={`Because You Viewed ${label}`}
        products={state.items}
        action={<Link to={`/category/${state.slug}`} className="text-emerald font-semibold text-sm">More →</Link>}
      />
    </div>
  );
}
